<div class="chat-room h-full flex flex-col">
  <div class="chat-room-controls flex justify-end">
    <y42-chat-resolve-button
      *ngIf="isResolveable"
      (resolved)="onResolved()"
      [tooltip]="'Resolve conversation'"
    ></y42-chat-resolve-button>
  </div>

  <div
    *ngIf="conversation.length > 0; else noMessagesYet"
    class="chat-room-messages flex flex-col"
    #chatMessages
    (scroll)="chatMessagesScrolled($event)"
  >
    <y42-chat-message
      *ngFor="let message of conversation; trackBy: trackByID"
      class="mt-1 mb-1 message-id-{{ message.id }}"
      [message]="message"
      [mentionUsers]="mentionUsers"
      [highlight]="state.highlight === message.id"
      (edited)="onEdited($event)"
      (editPhase)="editPhaseChanged()"
      (deleted)="onDeleted($event)"
    ></y42-chat-message>
  </div>

  <div class="chat-room-new-message" *ngIf="author">
    <y42-chat-input [avatar]="author" [mentionUsers]="mentionUsers" (commented)="onNewComment($event)"></y42-chat-input>
  </div>
</div>

<ng-template #noMessagesYet>
  <div class="empty-table h-full">
    <img height="80" src="assets/images/not-available/no-chat.svg" />
    <div class="empty-table-header">No Messages</div>
  </div>
</ng-template>
